import CacheableDataObject from './CacheableDataObject';


export default class TransactionSplit extends CacheableDataObject {
	beforeConstruct() {
		this.category_id = null;
		this.amount = 0;
		/** What this part of the charge was, e.g. an imported order's line item. */
		this.description = null;
		/** The import source's id for the item, which a later import recognises it by. */
		this.external_id = null;
	}

	isUnset() {
		return this.category_id === null;
	}

	clone() {
		const split = new TransactionSplit();
		split.amount = this.amount;
		split.category_id = this.category_id;
		split.description = this.description;
		split.external_id = this.external_id;
		return split;
	}

	serialize() {
		const data = {};
		data.category_id = this.category_id;
		data.amount = this.amount;
		/**
		 * Sent back because saving recreates every split that arrives without an id, and a clone has
		 * none: leaving these off would drop an imported split's note on its first edit.
		 */
		data.description = this.description;
		data.external_id = this.external_id;
		return data;
	}
}
TransactionSplit.prototype.dataLocationParsers = {
	category_id: (split, data) => {
		split.category_id = data.category_id;
	},
	amount: (split, data) => {
		split.amount = Number.parseInt(data.amount, 10);
	},
};